var _circle, _circle2, _g, _path, _path2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup10000117031(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1601,
    cy: 29.2,
    r: 28.8,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_627_7195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 58
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1601,
    cy: 29.2,
    r: 28.08,
    fill: "black",
    stroke: "white",
    strokeWidth: 1.44
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_627_7195)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.651,
    y: -36.9091,
    width: 53.0182,
    height: 80.533,
    transform: "rotate(45 20.651 -36.9091)",
    fill: "url(#paint0_linear_627_7195)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.651 43.4551V15.5995C20.651 15.1788 20.9965 14.8 21.4715 14.8H31.534C36.63 14.8 40.8191 18.2084 40.8191 22.6265C40.8191 25.8665 37.8392 28.2229 35.8095 29.2749C38.0984 30.2006 41.5965 32.2624 41.5965 36.1336C41.5965 40.8463 37.321 44.2546 32.1818 44.2546H21.4715C20.9965 44.2546 20.651 43.8759 20.651 43.4551ZM27.3881 26.7502H30.7566C32.3977 26.7502 33.7797 25.4037 33.7797 23.7206C33.7797 22.0375 32.3977 20.8593 30.7566 20.8593H27.3881V26.7502ZM27.3881 38.2375H31.3181C33.0023 38.2375 34.4275 36.891 34.4275 35.1658C34.4275 33.4826 32.5705 32.2203 30.8862 32.2203H27.3881V38.2375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6124 22.7918C11.4874 22.6737 11.4498 22.6264 11.5499 22.4609L12.1377 21.48C12.2378 21.3264 12.4754 21.35 12.563 21.4091C12.613 21.4327 13.5135 22.0591 14.339 22.0591C14.8393 22.0591 15.202 21.7637 15.202 21.35C15.202 20.8537 14.7643 20.4755 13.9138 20.1564C12.8381 19.7546 11.4874 18.9627 11.4874 17.5446C11.4874 16.3746 12.4504 15.1927 14.3765 15.1927C15.6773 15.1927 16.6779 15.8191 17.0531 16.0791C17.2032 16.1618 17.1782 16.3746 17.1281 16.4573L16.4903 17.3673C16.4027 17.4973 16.1776 17.6037 16.065 17.5209C15.9524 17.4618 15.0394 16.8118 14.2765 16.8118C13.8262 16.8118 13.4885 17.0955 13.4885 17.4146C13.4885 17.8518 13.8637 18.1827 14.8518 18.5609C15.8274 18.9273 17.3783 19.6482 17.3783 21.2555C17.3783 22.4727 16.2651 23.7018 14.4266 23.7018C12.8006 23.7018 11.9001 23.0637 11.6124 22.7918Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1601,
    cy: 29.2,
    r: 28.08,
    stroke: "white",
    strokeWidth: 1.44
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_627_7195",
    x1: 47.1601,
    y1: -36.9091,
    x2: 47.1601,
    y2: 43.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC20D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE6E3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10000117031);
export default __webpack_public_path__ + "static/media/Group 1000011703-1.fd6f9aea627fb17afc329e38940356be.svg";
export { ForwardRef as ReactComponent };